<template>
  <div>
    <!-- 分销订单 -->
    <x-tabula
      ref="table"
      rowKey=""
      :dataSource="dataSource"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :rowSelection="false"
    >
      <template slot="opt_h" slot-scope="{row}">
        <span><a @click="toDetail(row.orderId,row.type)">{{ row.orderId}}</a></span>
      </template>
      <template slot="opt_type" slot-scope="{row}">
        <span>{{ getOrderTypeDesc(row.type)}}</span>
      </template>
    </x-tabula>
  </div>
</template>

<script>
export default {
  name: 'distributionOrders',
  data () {
    return {

      dataSource: [],
      searchList: [
        {props: ['title'], placeholder: '商品', inputType: 'input'},
        {props: ['type'], placeholder: '类型', inputType: 'select', options: []},
        {props: ['status'], placeholder: '状态', inputType: 'select', options: []},
        {props: ['mobile'], placeholder: '账号', inputType: 'input'},
        {props: ['orderId'], placeholder: '订单编号', inputType: 'input'},
        {props: ['subId'], placeholder: '子订单编号', inputType: 'input'},
        {props: ['payDate'], placeholder: ['付款起始时间', '付款截止时间'], inputType: 'datePick'},
        {props: ['settleDate'], placeholder: ['结算起始时间', '结算截止时间'], inputType: 'datePick'},
        {props: ['distribution'], placeholder: '推广者名称/推广者ID', inputType: 'input'}
      ],
      columns: [
        {title: '订单编号', dataIndex: 'orderId', align: '', width: '', scopedSlots: {customRender: 'h'}},
        {title: '子订单编号', dataIndex: 'subId', align: '', width: ''},
        {title: '商品', dataIndex: 'title', align: '', width: ''},
        {title: '类型', dataIndex: 'type', align: '', width: '', scopedSlots: {customRender: 'type'}},
        {title: '店铺名称', dataIndex: 'shopName', align: '', width: ''},
        {title: '昵称', dataIndex: 'name', align: '', width: ''},
        {title: '账号', dataIndex: 'mobile', align: '', width: ''},
        {title: '付款时间', dataIndex: 'payTime', align: '', width: ''},
        {title: '结算金额', dataIndex: 'settleFee', align: '', width: ''},
        {title: '佣金率', dataIndex: 'commissionPoint', align: '', width: '', customCell: (row) => ({ domProps: { innerHTML: row.commissionPoint + '%'} })},
        {title: '佣金', dataIndex: 'commissionFee', align: '', width: ''},
        {title: '状态', dataIndex: 'statusDesc', align: '', width: ''},
        {title: '结算时间', dataIndex: 'settleTime', align: '', width: ''},
        {title: '推广者', dataIndex: 'distributionName', align: '', width: ''}
      ],
      tableOptList: [],

      searchParams: {
        title: undefined,
        type: undefined,
        status: undefined,
        mobile: undefined,
        orderId: undefined,
        subId: undefined,
        payDate: undefined,
        settleDate: undefined,
        distribution: undefined
      },
      listApi: {
        url: '/local/distribution/list',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {},
      deleteParam: {},
      dataArr: {}
    };
  },
  mounted () {
  },
  methods: {
    getSelect () {
      // 获取类型下拉
      this.$get({
        url: '/dict/data/dictType/comu_local_good_type',
        params: {}
      }).then(({data}) => {
        this.searchList[1].options = data;
      });
      // 获取支付状态
      this.$get({
        url: '/dict/data/dictType/comu_order_distribution_status',
        params: {}
      }).then(({data}) => {
        this.searchList[2].options = data;
      });

      // 获取使用状态
      this.$get({
        url: '/dict/data/dictType/comu_local_use_status',
        params: {}
      }).then(({data}) => {
        this.dataArr.a = data;
      });

      // 获取退款类型
      this.$get({
        url: '/dict/data/dictType/comu_local_sales_status',
        params: {}
      }).then(({data}) => {
        this.dataArr.b = data;
      });
      // 获取结算类型
      this.$get({
        url: '/dict/data/dictType/comu_local_settle_status',
        params: {}
      }).then(({data}) => {
        this.dataArr.c = data;
      });
    },
    getDesc (type, typeArr) {
      for (let i = 0; i < typeArr.length; i++) {
        if (typeArr[i].value === type + '') {
          return typeArr[i].label;
        }
      }
      return '';
    },
    // 活动类型1：活动 2：团购 3：商家
    getOrderTypeDesc (type) {
      return this.getDesc(type, this.searchList[1].options);
    },

    // 支付状态 0待付款 1已付款  2已超时/关闭  3已退款（全部退款才会更新为该状态）
    getOrderStatusTypeDesc (type) {
      return this.getDesc(type, this.searchList[2].options);
    },

    getUseStatusDesc (type) {
      return this.getDesc(type, this.dataArr.a);
    },

    // 是否售后 - 0无，1存在退款
    getSalesStatusTypeDesc (type) {
      return this.getDesc(type, this.dataArr.b);
    },
    // 0未结算，1待结算，2部分结算，3全部结算
    getSettleStatusTypeDesc (type) {
      return this.getDesc(type, this.dataArr.c);
    },
    toDetail (id, type) {
      this.$router.push({
        name: 'localOrderDetail',
        query: {
          id: id,
          type,
          methods: {
            getOrderTypeDesc: this.getOrderTypeDesc,
            getOrderStatusTypeDesc: this.getOrderStatusTypeDesc,
            getUseStatusDesc: this.getUseStatusDesc,
            getSalesStatusTypeDesc: this.getSalesStatusTypeDesc,
            getSettleStatusTypeDesc: this.getSettleStatusTypeDesc
          },
          ...this.breadParam(this)
        }
      });
    }
  },
  created () {
    this.getSelect();
  }
};
</script>
<style scoped>

</style>
